import getOpeningHours from '@ahmdigital/logic/lib/utils/get-opening-hours';

import { FooterStaticProps } from '../../types';
import AWARDS from '../../../../components/awards/data/awards';
import config from '../../../../config';
import constants from '../../../../ahm-constants';

const getStaticProps = (): FooterStaticProps => ({
  acknowledgementImage: constants.URLS.FILES.ACKNOWLEDGEMENT_FLAGS,
  appCalloutIcons: {
    android: {
      image: constants.URLS.FILES.APP_IMAGES.GOOGLE,
      link: constants.URLS.APP_STORE.ANDROID,
    },
    ios: {
      image: constants.URLS.FILES.APP_IMAGES.APPLE,
      link: constants.URLS.APP_STORE.IOS,
    },
  },
  awardsImages: AWARDS.images,
  contacts: [
    {
      contactHours: getOpeningHours(constants.AHM_SERVICE_NAME.SALES),
      contactNumber: '134 246',
    },
  ],
  logo: {
    alt: 'Go to ahm home',
    image: `${config.get('static:url')}/files/images/logos/ahm-logo-white.svg`,
    linkTo: constants.URLS.SALES.HOME,
    title: 'Go to ahm home',
  },
  navLinks: [
    {
      linkTo: constants.URLS.SALES.SITEMAP,
      name: 'Sitemap',
    },
    {
      linkTo: constants.URLS.SALES.TERMS_AND_CONDITIONS,
      name: 'Terms and conditions',
    },
    {
      linkTo: constants.URLS.SALES.PRIVACY,
      name: 'Privacy policy',
    },
    {
      linkTo: constants.URLS.THIRD_PARTY.CAREERS,
      name: 'Careers',
    },
    {
      linkTo: constants.URLS.SALES.DOWNLOADS,
      name: 'Forms and guides',
    },
    {
      linkTo: constants.URLS.SALES.ABOUT,
      name: 'About us',
    },
  ],
});

export default getStaticProps;
